/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  createContext,
  useReducer,
  ReactNode,
  useContext,
  useEffect,
  useCallback,
} from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import moment from "moment";
import { getQuarterRanges } from "./convertionHealper";
import useIPMSApi from "./ipms";
import {
  ApprovalEmployeeList,
  ChangeApprovalEmployeeListResponse,
  createEditGoalsPayload,
  CreateMasterGoalPayload,
  // CreateUpdateResponsePayload,
  EmployeeprojectApprovalList,
  GetDeleteEmployeeGoalAssessmentPayload,
  // GetEmpGoalAssessmentBymanagerPayload,
  // GetEmpGoalAssessmentBymanagerResponse,
  GetEmpGoalFinalAssessmentBymanagerPayload,
  GetEmpGoalFinalAssessmentBymanagerResponse,
  // GetEmployeeGoalAssessmentPayload,
  // GetEmployeeGoalDataResponse,
  // GetEmployeeGoalResponse,
  // GetGoalsAssessmentsResponse,
  GetIPMSGoalResponse,
  // QResponse,
  // QResponseData,
  MasterGoalsResponse,
  QuarterDates,
  // QuartersResponse,
  // UpdateGoalsAssessmentsPayload,
} from "./ipmsmodel";
import {
  getCookieData,
  getUserIdTokenForIPMSEmployid,
  setCookieData,
  setEmployeeID,
} from "../../helper/api";
import { adminpayload, DepartmentResponse } from "../../model/adminModel";
import useAdminApi from "../../api/admin";
import { useNavigate } from "react-router-dom";
import { AssessmentPeriodPayload, AssessmentPeriodResponseModel, GetEmployeeGoalDataResponse, GetEmployeeGoalPayload, Quarters, N1, CreateUpdateGoalsPayload, GetEmpGoalAssessmentBymanagerResponse, GetEmpGoalAssessmentBymanagerPayload, GetEmployeeGoalAssessmentPayload, GetAssessmentStatusResponse, GetGoalAssessmentPayload, GetGoalsAssessmentsResponseData, SaveGoalAssessmentPayload, SaveGoalAssessmentByManagerResponse, SaveGoalAssessmentByHrResponse, AppraiserDataResponse } from "./newipmsmodel";

// Utility function to create default quarters data
const createDefaultQuarters = (
  quartersList: string[],
  defaultValue: N1
): Quarters => {
  const quarters: Quarters = {};
  quartersList.forEach((quarter) => {
    // quarters[quarter] = { ...defaultValue };
    quarters[quarter] = JSON.parse(JSON.stringify(defaultValue));
  });
  return quarters;
};

// Default value for N1
export const defaultValue: N1 = {
  kra: [],
  soft: [],
  org: [],
  status: "DRAFT",
};

// List of quarters
const quarterList = ["q1", "q2", "q3", "q4"];

// Create the Quarters object dynamically
const defaultQuartersData = createDefaultQuarters(quarterList, defaultValue);

// Default Employee Goal object
export const defaultEmployeeGoal: GetEmployeeGoalDataResponse = {
  employee_id: 0,
  assessment_year: 0,
  manager_name: "",
  approver_id: 0,
  kra_options: [],
  isNew: false,
  quarters: defaultQuartersData,
  goal_assessment_status: [],
};

// Define the context types
interface ManageIPMSContextType {
  selectedAssessmentPeriod: string;
  assessmentData: AssessmentPeriodResponseModel | null;
  GetIpmsEmployeeData: GetEmployeeGoalDataResponse | null;
  GetIpmsEmployeeGoalsData: GetEmployeeGoalDataResponse | null;
  GetIpmsEmployeeGoalAssessmentData: GetGoalsAssessmentsResponseData | null;
  GetIpmsAssessmentStatusDataList: GetAssessmentStatusResponse[] | null;
  GetIpmsEmployeeGoalAssessmentByManagerData:
  | GetEmpGoalAssessmentBymanagerResponse[]
  | null;
  GetIpmsEmployeeGoalFinalAssessmentByManagerData:
  | GetEmpGoalFinalAssessmentBymanagerResponse[]
  | null;
  GetIpmsEmployeeGoalFinalAssessmentViewData:
  | GetEmpGoalFinalAssessmentBymanagerResponse[]
  | null;
  dispatch: React.Dispatch<Action>;
  GetEmployeeGoal: (item: GetEmployeeGoalPayload) => void;
  getAssessmentPeriods: (item: AssessmentPeriodPayload) => void;
  addandupdateGoal: (item: CreateUpdateGoalsPayload) => void;
  rejectGoal: (item: GetEmployeeGoalAssessmentPayload) => void;
  deleteGoal: (item: { employee_id: number; assessment_year: number }) => void;
  GetEmployeeGoalsAssessmentData: (item: GetEmployeeGoalPayload) => void;
  GetEmployeeGoalAssessment: (item: GetGoalAssessmentPayload) => void;
  GetEmployeeGoalAssessmentByManager: (
    item: GetEmpGoalAssessmentBymanagerPayload
  ) => void;
  GetEmployeeGoalFinalAssessmentByManager: (
    item: GetEmpGoalAssessmentBymanagerPayload
  ) => void;
  updateGoalsAssessmentsDataByEmployee: (
    item: SaveGoalAssessmentPayload,
    formType: string
  ) => void;
  updateGoalsAssessmentsDataByManager: (
    item: SaveGoalAssessmentByManagerResponse,
    formType: string
  ) => void;
  updateGoalsAssessmentsDataByHr: (
    item: SaveGoalAssessmentByHrResponse,
    formType: string
  ) => void;
  rejectGoalsAssessmentsData: (
    item: SaveGoalAssessmentPayload
  ) => void;
  listDepartment: DepartmentResponse[] | null;
  getAllDepartment: (item: adminpayload) => void;
  addandupdateGoals: (
    item: CreateMasterGoalPayload,
    formType: string,
    goalID: number | null
  ) => void;
  removeGoals: (item: number) => void;
  listGoalsData: MasterGoalsResponse | null;
  getIpmsGoalsData: () => void;
  approveEmployeeGoals: (item: GetEmployeeGoalAssessmentPayload) => void;
  GetEmployeeGoalFinalAssessmentView: (
    item: GetEmpGoalFinalAssessmentBymanagerPayload
  ) => void;
  listAppriserEmployee: ApprovalEmployeeList[] | null;
  getAppriserEmployeeList: (item: { searchname: string }) => void;
  QuarterAppriserEmployeeList: ChangeApprovalEmployeeListResponse[] | null;
  getEmployeequarterAppriserList: (item: { searchname: string }) => void;
  TSApproverList: EmployeeprojectApprovalList[] | null;
  getEmployeeTSApproverList: (item: { employee_id: number }) => void;
  employeeassessmentData: QuarterDates | null;
  setQuarterAppriserEmployeeList: (
    data: ChangeApprovalEmployeeListResponse[]
  ) => void;
}

// Define the initial state
const initialState: ManageIPMSContextType = {
  selectedAssessmentPeriod: "",
  assessmentData: null,
  GetIpmsEmployeeData: defaultEmployeeGoal,
  GetIpmsEmployeeGoalsData: null,
  GetIpmsEmployeeGoalAssessmentData: null,
  GetIpmsAssessmentStatusDataList: null,
  GetIpmsEmployeeGoalAssessmentByManagerData: null,
  GetIpmsEmployeeGoalFinalAssessmentByManagerData: null,
  GetIpmsEmployeeGoalFinalAssessmentViewData: null,
  dispatch: () => null,
  GetEmployeeGoal: () => { },
  getAssessmentPeriods: () => { },
  addandupdateGoal: () => { },
  rejectGoal: () => { },
  deleteGoal: () => { },
  GetEmployeeGoalsAssessmentData: () => { },
  GetEmployeeGoalAssessment: () => { },
  GetEmployeeGoalAssessmentByManager: () => { },
  GetEmployeeGoalFinalAssessmentByManager: () => { },
  updateGoalsAssessmentsDataByEmployee: () => { },
  updateGoalsAssessmentsDataByManager: () => { },
  updateGoalsAssessmentsDataByHr: () => { },
  rejectGoalsAssessmentsData: () => { },
  listDepartment: null,
  getAllDepartment: () => { },
  addandupdateGoals: () => { },
  removeGoals: () => { },
  listGoalsData: null,
  getIpmsGoalsData: () => { },
  approveEmployeeGoals: () => { },
  GetEmployeeGoalFinalAssessmentView: () => { },
  listAppriserEmployee: [],
  getAppriserEmployeeList: () => { },
  QuarterAppriserEmployeeList: null,
  getEmployeequarterAppriserList: () => { },
  TSApproverList: [],
  getEmployeeTSApproverList: () => { },
  employeeassessmentData: null,
  setQuarterAppriserEmployeeList: () => { },
};

// Define the action types
type Action =
  | { type: "SET_SELECTED_ASSESSMENT_PERIOD"; payload: string }
  | {
    type: "SET_ASSESSMENT_DATA";
    payload: AssessmentPeriodResponseModel | null;
  }
  | { type: "SET_EMPLOYEE_DATA"; payload: GetEmployeeGoalDataResponse | null }
  | {
    type: "SET_EMPLOYEE_GOALS_DATA";
    payload: GetEmployeeGoalDataResponse | null;
  }
  | {
    type: "SET_ASSESSMENT_STATUS_DATA_LIST";
    payload: GetAssessmentStatusResponse[] | null;
  }
  | {
    type: "SET_EMPLOYEE_GOAL_ASSESSMENT_DATA";
    payload: GetGoalsAssessmentsResponseData | null;
  }
  | {
    type: "SET_EMPLOYEE_GOAL_FINAL_ASSESSMENT_BY_MANAGER_DATA";
    payload: GetEmpGoalFinalAssessmentBymanagerResponse[] | null;
  }
  | {
    type: "SET_EMPLOYEE_GOAL_FINAL_ASSESSMENT_BY_HR_DATA";
    payload: GetEmpGoalFinalAssessmentBymanagerResponse[] | null;
  }
  | {
    type: "SET_EMPLOYEE_GOAL_ASSESSMENT_BY_MANAGER_DATA";
    payload: GetEmpGoalAssessmentBymanagerResponse[] | null;
  }
  | {
    type: "UPDATE_GOAL_ASSESSMENT";
    payload: {
      tableKey: string;
      index: number;
      columnKey: string;
      value: string;
      quarterName: string;
    };
  }
  | {
    type: "SET_EMPLOYEE_ASSESSMENT_DATA";
    payload: QuarterDates | null;
  };

// Reducer function
const manageIPMSReducer = (
  state: ManageIPMSContextType,
  action: Action
): ManageIPMSContextType => {
  switch (action.type) {
    case "SET_SELECTED_ASSESSMENT_PERIOD":
      return { ...state, selectedAssessmentPeriod: action.payload };
    case "SET_ASSESSMENT_DATA":
      return { ...state, assessmentData: action.payload };
    case "SET_EMPLOYEE_ASSESSMENT_DATA":
      return { ...state, employeeassessmentData: action.payload };
    case "SET_EMPLOYEE_DATA":
      return { ...state, GetIpmsEmployeeData: action.payload };
    case "SET_EMPLOYEE_GOALS_DATA":
      return { ...state, GetIpmsEmployeeGoalsData: action.payload };
    case "SET_ASSESSMENT_STATUS_DATA_LIST":
      return { ...state, GetIpmsAssessmentStatusDataList: action.payload };
    case "SET_EMPLOYEE_GOAL_ASSESSMENT_DATA":
      return { ...state, GetIpmsEmployeeGoalAssessmentData: action.payload };
    case "SET_EMPLOYEE_GOAL_ASSESSMENT_BY_MANAGER_DATA":
      return {
        ...state,
        GetIpmsEmployeeGoalAssessmentByManagerData: action.payload,
      };
    case "SET_EMPLOYEE_GOAL_FINAL_ASSESSMENT_BY_MANAGER_DATA":
      return {
        ...state,
        GetIpmsEmployeeGoalFinalAssessmentByManagerData: action.payload,
      };
    case "SET_EMPLOYEE_GOAL_FINAL_ASSESSMENT_BY_HR_DATA":
      return {
        ...state,
        GetIpmsEmployeeGoalFinalAssessmentViewData: action.payload,
      };
    case "UPDATE_GOAL_ASSESSMENT": {
      const { tableKey, index, columnKey, value, quarterName } = action.payload as any;
      if (!state.GetIpmsEmployeeGoalAssessmentData) return state;

      const updatedData = { ...state.GetIpmsEmployeeGoalAssessmentData };
      const currentQuarter = updatedData[quarterName] || {
        goals: [],
        org_goals: [],
        soft_goals: [],
        training: [],
        header: {
          emp_overall_comment: "",
          mgr_overall_comment: "",
          mgr_rating_kra: 0,
          mgr_rating_soft: 0,
          bonus_rating: 0,
          final_rating: 0,
          hr_comment: "",
          goal_status: "",
          assessment_status: "",
          manager_id: 0,
          id: 0,
        },
      };

      const updatedQuarter = { ...currentQuarter };

      if (tableKey === "quater_data" || tableKey === "goals") {
        const goals = [...(updatedQuarter.goals || [])];
        goals[index] = {
          ...goals[index],
          [columnKey]: value,
        };
        updatedQuarter.goals = goals;
      } else if (tableKey === "org_goals") {
        const orgGoals = [...(updatedQuarter.org_goals || [])];
        orgGoals[index] = {
          ...orgGoals[index],
          [columnKey]: value,
        };
        updatedQuarter.org_goals = orgGoals;
      } else if (tableKey === "soft_goals") {
        const softGoals = [...(updatedQuarter.soft_goals || [])];
        softGoals[index] = {
          ...softGoals[index],
          [columnKey]: value,
        };
        updatedQuarter.soft_goals = softGoals;
      } else if (tableKey === "training") {
        const training = [...(updatedQuarter.training || [])];
        training[index] = {
          ...training[index],
          [columnKey]: value,
        };
        updatedQuarter.training = training;
      } else if (tableKey === "other" || tableKey === "header") {
        updatedQuarter.header = {
          ...(updatedQuarter.header || {}),
          [columnKey]: value,
        };
      } else if (tableKey === "employees_Inputs") {
        updatedQuarter.header = {
          ...(updatedQuarter.header || {}),
          emp_extra_comments: value,
        };
      } else if (tableKey === "manager_Inputs") {
        updatedQuarter.header = {
          ...(updatedQuarter.header || {}),
          mgr_extra_comments: value,
        };
      } else if (tableKey === "hr_Inputs") {
        updatedQuarter.header = {
          ...(updatedQuarter.header || {}),
          hr_extra_comments: value,
        };
      }

      updatedData[quarterName] = updatedQuarter as any;

      return { ...state, GetIpmsEmployeeGoalAssessmentData: updatedData };
    }
    default:
      return state;
  }
};

const ManageIPMSContext = createContext<ManageIPMSContextType>(initialState);

export const ManageIPMSProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const userData = getCookieData("userData");
  const currentUser = userData ? JSON.parse(userData) : null;
  const [listDepartment, setListDepartment] = React.useState<
    DepartmentResponse[] | null
  >(null);
  const queryClient = useQueryClient();
  const [listGoalsData, setListGoalsData] =
    React.useState<MasterGoalsResponse | null>(null);
  const [listAppriserEmployee, setListAppriserEmployee] = React.useState<
    ApprovalEmployeeList[] | null
  >(null);
  const [QuarterAppriserEmployeeList, setQuarterAppriserEmployeeList] =
    React.useState<ChangeApprovalEmployeeListResponse[] | null>(null);
  const [TSApproverList, setTSApproverList] = React.useState<
    EmployeeprojectApprovalList[] | null
  >(null);
  const [state, dispatch] = useReducer(manageIPMSReducer, initialState);
  const navigate = useNavigate();
  // const value = getCookieData("goalsDate");
  const ipmsID = getUserIdTokenForIPMSEmployid();
  const {
    fetchGetIpmsEmployeeData,
    createupdateIpms,
    rejectGoalsIpms,
    deleteGoalsIpms,
    fetchGetIpmsAssessmentPeriods,
    fetchGetIpmsEmployegoalAssessments,
    fetchGetIpmsEmployeGetgoalAssessment,
    updateGoalsAssessments,
    rejectGoalsAssessments,
    updateGoalsAssessmentsByManager,
    updateGoalsAssessmentsByHr,
    fetchGetIpmsGetEmpAssessmentByManager,
    CreateupdateGoals,
    fetchGetIpmsGoalsData,
    deleteGoals,
    approveEmployeeGoalsIpms,
    // fetchGetIpmsGetEmpFinalAssessmentByManager,
    fetchGetIpmsGetEmpFinalAssessmentview,
    fetchGetIpmsGetEmpAppriserList,
    fetchGetIpmsGetEmpget_quarterAppriserList,
    // fetchgetEmployeeTSApproverList,
  } = useIPMSApi();

  const { fetchGetDepartment } = useAdminApi();

  const GetEmployeeGoalsAssessmentData = useCallback(
    async (payload: GetEmployeeGoalPayload) => {
      try {
        setCookieData("goalsDate", payload.start_assessment_date);
        const response = await fetchGetIpmsEmployegoalAssessments({
          employee_id: payload.employee_id,
          assessment_year: moment(payload.start_assessment_date).year(),
        });
        dispatch({ type: "SET_ASSESSMENT_STATUS_DATA_LIST", payload: response });
      } catch (error) {
        // Handle error
      }
    },
    []
  );

  const { data: assessmentPeriodsData, isSuccess: isAssessmentSuccess } = useQuery({
    queryKey: ["assessmentPeriods", currentUser?.ldap_uid],
    queryFn: async () => {
      if (!currentUser?.ldap_uid) return null;
      return fetchGetIpmsAssessmentPeriods({ username: currentUser.ldap_uid });
    },
    enabled: !!currentUser?.ldap_uid,
    staleTime: Infinity,
  });

  useEffect(() => {
    if (isAssessmentSuccess && assessmentPeriodsData) {
      if (assessmentPeriodsData?.assessment_periods?.[0]) {
        const start = moment(
          assessmentPeriodsData.assessment_periods[0].start_assessment_date
        );
        const end = moment(
          assessmentPeriodsData.assessment_periods[0].end_assessment_date
        );
        const ranges = getQuarterRanges(start, end);

        const quarterList: any = {};
        ranges.forEach((r, i) => {
          quarterList[`q${i + 1}`] = {
            start: r.start?.format("YYYY-MM-DD") || "",
            end: r.end?.format("YYYY-MM-DD") || "",
          };
        });

        dispatch({
          type: "SET_EMPLOYEE_ASSESSMENT_DATA",
          payload: quarterList,
        });
        setCookieData("assessmentData", JSON.stringify(quarterList));
      }

      const storedDate = getCookieData("goalsDate");
      const todayStr = moment().format("YYYY-MM-DD");
      const currentPeriod = assessmentPeriodsData?.assessment_periods?.find(
        (p) => todayStr >= p.start_assessment_date && todayStr <= p.end_assessment_date
      );
      const defaultDate = (storedDate && assessmentPeriodsData?.assessment_periods?.some(p => p.start_assessment_date === storedDate))
        ? storedDate
        : currentPeriod
        ? currentPeriod.start_assessment_date
        : assessmentPeriodsData?.assessment_periods?.[0]?.start_assessment_date || "";

      dispatch({
        type: "SET_SELECTED_ASSESSMENT_PERIOD",
        payload: defaultDate,
      });
      dispatch({ type: "SET_ASSESSMENT_DATA", payload: assessmentPeriodsData });

      if (assessmentPeriodsData && ipmsID && defaultDate) {
        setEmployeeID(Number(ipmsID));
        GetEmployeeGoalsAssessmentData({
          employee_id: Number(ipmsID),
          start_assessment_date: defaultDate,
        });
      }
    }
  }, [
    assessmentPeriodsData,
    isAssessmentSuccess,
    ipmsID,
    GetEmployeeGoalsAssessmentData,
    dispatch,
  ]);

  // Function exposed in context, now simplified or unused within context (relies on useQuery)
  const getAssessmentPeriods = useCallback(
    async (_payload: AssessmentPeriodPayload) => {
      // Optional: Explicit refetch if needed
      console.log('getAssessmentPeriods called', _payload)
      queryClient.invalidateQueries({ queryKey: ["assessmentPeriods", currentUser?.ldap_uid] });
    },
    [queryClient, currentUser]
  );

  const GetEmployeeGoal = useCallback(
    async (payload: GetEmployeeGoalPayload) => {
      console.log("payload ===> ", payload);
      try {
        const response: any = await queryClient.fetchQuery({
          queryKey: ["employeeGoal", payload],
          queryFn: () => fetchGetIpmsEmployeeData(payload),
          retry: 0,
          // staleTime: 1000 * 60 * 5,
        });

        dispatch({
          type: "SET_EMPLOYEE_DATA",
          payload: response ?? defaultEmployeeGoal,
        });
        if (response?.approver_id && response?.manager_name) {
          setTSApproverList([{ employee_id: response.approver_id, full_name: response.manager_name }] as any);
        } else {
          setTSApproverList([]);
        }

        // console.log("response ===> ", response);
        // dispatch({
        //   type: "SET_EMPLOYEE_ASSESSMENT_DATA",
        //   payload: response?.quarterList ?? null,
        // });
        return response;
      } catch (error) {
        // Handle error
      }
    },
    [fetchGetIpmsEmployeeData, queryClient, dispatch]
  );

  const GetEmployeeGoalAssessment = useCallback(
    async (payload: GetGoalAssessmentPayload) => {
      try {
        const response = await fetchGetIpmsEmployeGetgoalAssessment(payload);
        dispatch({
          type: "SET_EMPLOYEE_GOAL_ASSESSMENT_DATA",
          payload: response,
        });
      } catch (error) {
        // Handle error
      }
    },
    []
  );

  const GetEmployeeGoalAssessmentByManager = useCallback(
    async (payload: GetEmpGoalAssessmentBymanagerPayload) => {
      try {
        const response = await fetchGetIpmsGetEmpAssessmentByManager(payload);
        dispatch({
          type: "SET_EMPLOYEE_GOAL_ASSESSMENT_BY_MANAGER_DATA",
          payload: response?.items as any,
        });
      } catch (error) {
        // Handle error
      }
    },
    []
  );

  const GetEmployeeGoalFinalAssessmentByManager = useCallback(
    async (_payload: GetEmpGoalAssessmentBymanagerPayload) => {
      try {
        console.log('GetEmployeeGoalFinalAssessmentByManager called', _payload)
        // const response = await fetchGetIpmsGetEmpFinalAssessmentByManager(
        //   payload
        // );
        // dispatch({
        //   type: "SET_EMPLOYEE_GOAL_FINAL_ASSESSMENT_BY_MANAGER_DATA",
        //   payload: response,
        // });
      } catch (error) {
        // Handle error
      }
    },
    []
  );

  const GetEmployeeGoalFinalAssessmentView = useCallback(
    async (payload: GetEmpGoalFinalAssessmentBymanagerPayload) => {
      try {
        const response = await fetchGetIpmsGetEmpFinalAssessmentview(payload);
        dispatch({
          type: "SET_EMPLOYEE_GOAL_FINAL_ASSESSMENT_BY_HR_DATA",
          payload: response,
        });
      } catch (error) {
        // Handle error
      }
    },
    []
  );

  const approveEmployeeGoals = useCallback(
    async (payload: GetEmployeeGoalAssessmentPayload) => {
      try {
        const response = await approveEmployeeGoalsIpms(payload);
        if (response) {
          navigate(-1);
        }
        return response;
      } catch (error) {
        // Handle error
      }
    },
    []
  );

  const addandupdateGoal = useCallback(
    async (payload: CreateUpdateGoalsPayload) => {
      try {
        const response = await createupdateIpms(payload);
        if (response) {
          navigate(-1);
          queryClient.invalidateQueries({
            queryKey: ["employeeGoal", ipmsID],
          });
        }
        return response;
      } catch (error) {
        // Handle error
      }
    },
    []
  );

  const deleteGoal = useCallback(
    async (payload: { employee_id: number; assessment_year: number }) => {
      try {
        const response = await deleteGoalsIpms(payload);
        if (response) {
          navigate(-1);
        }
        return response;
      } catch (error) {
        // Handle error
      }
    },
    []
  );

  const rejectGoal = useCallback(
    async (payload: GetEmployeeGoalAssessmentPayload) => {
      try {
        const response = await rejectGoalsIpms(payload);
        if (response) {
          navigate(-1);
        }
        return response;
      } catch (error) {
        // Handle error
      }
    },
    []
  );

  const updateGoalsAssessmentsDataByEmployee = useCallback(
    async (payload: SaveGoalAssessmentPayload) => {
      try {
        const response = await updateGoalsAssessments(payload);
        if (response) {
          navigate(-1);
        }
        return response;
      } catch (error) {
        // Handle error
      }
    },
    []
  );

  const updateGoalsAssessmentsDataByManager = useCallback(
    async (payload: SaveGoalAssessmentByManagerResponse) => {
      try {
        const response = await updateGoalsAssessmentsByManager(payload);
        if (response) {
          navigate(-1);
        }
        return response;
      } catch (error) {
        // Handle error
      }
    },
    []
  );

  const updateGoalsAssessmentsDataByHr = useCallback(
    async (payload: SaveGoalAssessmentByHrResponse) => {
      try {
        const response = await updateGoalsAssessmentsByHr(payload);
        if (response) {
          navigate(-1);
        }
        return response;
      } catch (error) {
        // Handle error
      }
    },
    []
  );

  const rejectGoalsAssessmentsData = useCallback(
    async (payload: SaveGoalAssessmentPayload) => {
      try {
        const response = await rejectGoalsAssessments(payload)
        if (response) {
          navigate(-1);
        }
        return response;
      } catch (error) {
        // Handle error
      }
    },
    []
  );



  const getAllDepartment = React.useCallback(
    async (payload: adminpayload) => {
      try {
        const responseData = await fetchGetDepartment(
          payload.skip,
          payload.limit
        );
        setListDepartment(responseData);
        return responseData;
      } catch (error) {
        // setError(error.message);
      }
    },
    []
  );

  const getIpmsGoalsData = React.useCallback(async () => {
    try {
      const responseData = await fetchGetIpmsGoalsData();
      setListGoalsData(responseData);
      return responseData;
    } catch (error) {
      // setError(error.message);
    }
  }, []);

  const addandupdateGoals = useCallback(
    async (
      payload: CreateMasterGoalPayload,
      formType: string,
      goalID: number | null
    ) => {
      try {
        const response = await CreateupdateGoals(payload, formType, goalID);
        if (response) {
          navigate(-1);
        }
        return response;
      } catch (error) {
        // Handle error
      }
    },
    []
  );

  const removeGoals = useCallback(
    async (payload: number) => {
      try {
        const response = await deleteGoals(payload);
        if (response) {
          navigate(0);
        }
        return response;
      } catch (error) {
        // Handle error
      }
    },
    []
  );

  const getAppriserEmployeeList = useCallback(
    async (payload: { searchname: string }) => {
      try {
        const response = await fetchGetIpmsGetEmpAppriserList(payload);
        setListAppriserEmployee(response as typeof listAppriserEmployee);
        return response;
      } catch (error) {
        // Handle error
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const getEmployeequarterAppriserList = useCallback(
    async (payload: { searchname: string }) => {
      try {
        const response: AppraiserDataResponse[] = await fetchGetIpmsGetEmpget_quarterAppriserList(
          { employee_id: Number(payload.searchname) }
        );

        if (response) {
          const mappedResponse: ChangeApprovalEmployeeListResponse[] = response.map((item) => ({
            quarter: item.quarter_number,
            quarter_dates: `${item.period_start_date} to ${item.period_end_date}`,
            manager_name: item.manager_name,
            start_year: String(item.assessment_year),
          }));
          setQuarterAppriserEmployeeList(mappedResponse);
        } else {
          setQuarterAppriserEmployeeList(null);
        }
        return response;
      } catch (error) {
        // Handle error
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // const getEmployeeTSApproverList = useCallback(
  //   async (payload: { employee_id: number }) => {
  //     try {
  //       const response: any = await fetchgetEmployeeTSApproverList(payload);
  //       if (Array.isArray(response)) {
  //         setTSApproverList(response);
  //       } else if (response) {
  //         setTSApproverList([response]);
  //       }
  //       return response;
  //     } catch (error) {
  //       // Handle error
  //     }
  //   },
  //   [fetchgetEmployeeTSApproverList]
  // );

  return (
    <ManageIPMSContext.Provider
      value={{
        ...state,
        dispatch,
        GetEmployeeGoal,
        getAssessmentPeriods,
        addandupdateGoal,
        rejectGoal,
        deleteGoal,
        GetEmployeeGoalsAssessmentData,
        GetEmployeeGoalAssessment,
        GetEmployeeGoalAssessmentByManager,
        updateGoalsAssessmentsDataByEmployee,
        updateGoalsAssessmentsDataByManager,
        updateGoalsAssessmentsDataByHr,
        rejectGoalsAssessmentsData,
        getAllDepartment,
        listDepartment,
        addandupdateGoals,
        removeGoals,
        listGoalsData,
        getIpmsGoalsData,
        approveEmployeeGoals,
        GetEmployeeGoalFinalAssessmentByManager,
        GetEmployeeGoalFinalAssessmentView,
        listAppriserEmployee,
        getAppriserEmployeeList,
        QuarterAppriserEmployeeList,
        getEmployeequarterAppriserList,
        TSApproverList,
        // getEmployeeTSApproverList,
      }}
    >
      {children}
    </ManageIPMSContext.Provider>
  );
};

export const useManageIPMSContext = () => useContext(ManageIPMSContext);

export { ManageIPMSContext };
